import React from "react";
import axios from "axios";
import { useQuery } from "react-query";
import { useSearchParams } from "react-router-dom";
import { serverUrl } from "../../../../../nestserver";
import AddEditApplication from "./AddEditApplication";

const AdmissionApplicationPage = () => {
  // ?inquiry=<id> means the form was opened by "Convert" on an admission inquiry.
  const [searchParams, setSearchParams] = useSearchParams();
  const inquiryId = searchParams.get("inquiry");

  const inquiryQuery = useQuery(
    ["admission-inquiry", inquiryId],
    () =>
      axios
        .get(`${serverUrl}/admission-inquiry/${inquiryId}`, {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
          },
        })
        .then((res) => res.data),
    { enabled: !!inquiryId }
  );
  const inquiry =
    inquiryQuery.data?.success &&
    !["converted", "closed"].includes(inquiryQuery.data?.data?.status)
      ? inquiryQuery.data.data
      : undefined;

  const clearInquiry = () => {
    const next = new URLSearchParams(searchParams);
    next.delete("inquiry");
    setSearchParams(next, { replace: true });
  };

  return (
    <div className="admission mt-8">
      <div
        style={{ borderRadius: "10px", color: "#616161" }}
        className=" bg-white drop-shadow-md px-5 py-6 w-full "
      >
        <AddEditApplication inquiry={inquiry} onSubmitted={clearInquiry} />
      </div>
    </div>
  );
};

export default AdmissionApplicationPage;
